enum FormDensity {

  DEFAULT = 'default',
  CONFORTABLE = 'confortable',
  COMPACT = 'compact',
  
}

export default FormDensity;
